var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"common-card-wraper"},[_c('div',{staticClass:"title-wrapper",style:({ backgroundImage: `url(${_vm.topLogo})` })},[_vm._t("hd")],2),_c('div',{staticClass:"body-wrapper",style:({ backgroundImage: `url(${_vm.bottomlogo})` })},[_vm._t("bd")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }